// extracted by mini-css-extract-plugin
export default {"playerContainer":"Navbar_playerContainer__AU-Co","seatA":"Navbar_seatA__EwveJ","seatC":"Navbar_seatC__3a+rV","seatD":"Navbar_seatD__Oec+b","seatB":"Navbar_seatB__SHqvB"};